import brcClientConstants from './brcClientConstants';

const {PAYPAL_URL} = brcClientConstants;

const contactOptions = [
  {
    'id': 'help',
    'text': 'brc.HelpCenter',
    'message': 'message.helpCenter',
    'contactLinkCSS': '',
    'support': '',
    'iconCSS': 'icon-help',
    'url': PAYPAL_URL,
    'helpOption': '/selfhelp/home',
    'fpti':'brcHelpCenterClick'
  },
  {
    'id': 'community',
    'text': 'brc.CommunityForum',
    'message': 'message.communityForum',
    'contactLinkCSS': '',
    'support': '',
    'iconCSS': 'icon-community',
    'link': `https://www.paypal-community.com/t5/PayPal-Community/ct-p/`,
    'fpti':'brcCommunityClick'
  },
  {
    'id': 'resolution',
    'text': 'brc.ResolutionCenter',
    'message': 'message.resolutionCenter',
    'contactLinkCSS': '',
    'support': '',
    'iconCSS': 'icon-resolution',
    'link': PAYPAL_URL + 'signin/?returnUri=disputes',
    'fpti':'brcResolutionClick'
  },
  {
    'id': 'tax',
    'text': 'brc.TaxCenter',
    'message': 'message.taxCenter',
    'contactLinkCSS': '',
    'support': '',
    'iconCSS': 'icon-tax',
    'url': PAYPAL_URL,
    'helpOption': '/smarthelp/topic/TAX_CENTER',
    'fpti':'brcTaxCenterClick'
  },
  {
    'id': 'smart',
    'text': 'brc.Contactus',
    'message': 'message.contactus',
    'contactLinkCSS': '',
    'support': '',
    'iconCSS': 'icon-contact',
    'url': PAYPAL_URL,
    'helpOption': '/smarthelp/contact-us',
    'fpti':'brcContactUsClick'
  }
];

export default contactOptions;
